import { Box } from '@chakra-ui/react'
import { CsvExportBanner } from '../../context/CsvExportContext'


const BoxWrapper = ({ children }) => {
    return (
        <Box p={4} border={"1px solid #0000001a"} m={8} bg={"white"} borderRadius={"15px"}>
            <Box bg={"white"} p={2}>
                {/* Below the page header/nav (BoxWrapper is the shared content-card
                    convention almost every page opens with), not above it. */}
                <CsvExportBanner />
                {children}
            </Box>
        </Box>
    )
}

export default BoxWrapper